import { apiFetch } from "@/integrations/backend/client";

export type PricingTier = {
  id: string;
  name: string;
  blurb: string;
  features: string[];
  price_monthly: number;
  price_annual: number;
  stripe_price_id_monthly?: string | null;
  stripe_price_id_annual?: string | null;
  highlight: boolean;
  sort_order: number;
  created_at?: string;
};

export async function listPricingTiers(): Promise<PricingTier[]> {
  const res = await apiFetch("/api/v1/pricing-tiers", { method: "GET" });
  if (!res.ok) throw new Error(`pricing_list_failed:${res.status}`);
  return (await res.json()) as PricingTier[];
}

export async function createPricingTier(input: Omit<PricingTier, "id" | "created_at">): Promise<{ id: string }> {
  const res = await apiFetch("/api/v1/pricing-tiers", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(input),
  });
  if (!res.ok) throw new Error(`pricing_create_failed:${res.status}`);
  return (await res.json()) as { id: string };
}

export async function updatePricingTier(id: string, patch: Partial<PricingTier>): Promise<void> {
  const res = await apiFetch(`/api/v1/pricing-tiers/${id}`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(patch),
  });
  if (!res.ok) throw new Error(`pricing_update_failed:${res.status}`);
}

export async function deletePricingTier(id: string): Promise<void> {
  const res = await apiFetch(`/api/v1/pricing-tiers/${id}`, { method: "DELETE" });
  if (!res.ok) throw new Error(`pricing_delete_failed:${res.status}`);
}
